import { Component, Input, Output, EventEmitter, Optional, ElementRef, OnInit } from '@angular/core'
import { IcosRadioGroup } from './radio-group'
import { isParentTag, removeNgTag } from '../shared/utils'

@Component({
  selector: 'icos-radio-button',
  template: `
    <label
      [class]="'icos-radio-button' + (size ? ' icos-radio-button--' + size : '')"
      [class.is-disabled]="icosDisabled"
      [class.is-active]="model === label"
    >
      <input
        class="icos-radio-button__orig-radio"
        type="radio"
        [value]="label"
        [name]="nativeName"
        [disabled]="icosDisabled"
        [ngModel]="model"
        (ngModelChange)="changeHandle()"
      />
      <span class="icos-radio-button__inner" [ngStyle]="model === label && activeStyles">
        <ng-content></ng-content>
      </span>
    </label>
  `
})
export class IcosRadioButton implements OnInit {
  @Input() set disabled(val: boolean) {
    // todo, is discarded.
    console.warn('icos Angular: (disabled) is discarded, use [icosDisabled] replace it.')
  }
  @Input() icosDisabled: boolean = false
  @Input() label: string | number
  @Input('name') nativeName: string = ''
  @Input() model: any
  @Output() modelChange: EventEmitter<any> = new EventEmitter<any>()

  size: string
  showLabel: boolean = false
  parentIsGroup: boolean = false
  activeStyles: any

  constructor(@Optional() private rootGroup: IcosRadioGroup, private el: ElementRef) {}

  changeHandle(): void {
    if (this.parentIsGroup) {
      return this.rootGroup.changeHandle(this.label)
    }
    this.modelChange.emit(this.label)
  }

  ngOnInit(): void {
    const nativeElement = this.el.nativeElement
    const update = () => {
      this.icosDisabled = this.rootGroup.icosDisabled
      this.model = this.rootGroup.model
      this.size = this.rootGroup.buttonSize
      this.activeStyles = {
        backgroundColor: this.rootGroup.fillColor || '',
        borderColor: this.rootGroup.fillColor || '',
        boxShadow: this.rootGroup.fillColor ? `-1px 0 0 0 ${this.rootGroup.fillColor}` : '',
        color: this.rootGroup.textColor || ''
      }
    }
    this.parentIsGroup = isParentTag(nativeElement, 'icos-radio-group')
    removeNgTag(nativeElement)

    if (this.parentIsGroup && this.rootGroup) {
      update()
      this.rootGroup.subscriber.push(update)
    }
  }
}
